var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgErrorCircleFilledIcon = function SvgErrorCircleFilledIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-702.000000, -120.000000)",
    fill: "#cacfd3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690,100 C692.76348,100 695.120989,100.978081 697.0726,102.934272 C699.02421,104.890464 700,107.245683 700,110 C700,112.754317 699.02421,115.109536 697.0726,117.065728 C695.120989,119.021919 692.76348,120 690,120 C687.23652,120 684.879011,119.021919 682.9274,117.065728 C680.97579,115.109536 680,112.754317 680,110 C680,107.245683 680.967984,104.898288 682.903981,102.957746 C684.871204,100.985906 687.23652,100 690,100 Z M692.596491,106 L689.976608,108.588235 L687.403509,106 L686,107.411765 L688.573099,110 L686,112.588235 L687.403509,114 L689.976608,111.411765 L692.596491,114 L694,112.588235 L691.380117,110 L694,107.411765 L692.596491,106 Z",
    id: "ic_error_circle_filled"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorCircleFilledIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-circle-filled-icon.2b5026e4.svg";
export { ForwardRef as ReactComponent };